<template>
  <PageLayout>
    <template #header>
      <PageHeader :user-name="userDisplayName"
                  welcome-message="Willkommen zurück im Loop Dashboard"
                  @refresh="handleRefresh" />
    </template>

    <!-- Main Content -->
    <template #main>
      <!-- <BButton variant="light" size="sm" @click="fetchit(0)">
        <Search :size="12" class="me-1" />
        <span>Mode 0</span>
      </BButton>
      <BButton variant="light" size="sm" @click="fetchit(2)">
        <Search :size="14" class="me-1" />
        <span>Mode 2</span>
      </BButton> -->
      <div  v-if="boards"
            v-for="(board, idx) in boards" :key="idx">

        <div class="py-3">
          <KpiBoard v-if="board.type === 'kpi'"
                    :board-setup="board"
                    :board-data="boardData"
                    :kpis="focusKpis" />

          <WaveBoard  v-if="board.type === 'wave'"
                      :board-setup="board"
                      :board-data="boardData"
                      :wave-data="waveData"
                      @detail-click="handleWaveDetailClick"
                      @wave-click="handleWaveClick" />
        </div>

      </div>
    </template>

    <!-- Sidebar -->
    <!-- <template #sidebar>
      <PageSidebar title="Overview" :show-divider="true">
        <template #header>
          <h2 class="custom-title">Custom Overview Title</h2>
        </template>
        <template #body>
          <div class="overview-section">
            <p>Sidebar content goes here.</p>

            <div class="step-item">
              <div class="step-header">
                <span class="step-title">Step 1</span>
              </div>
              <div class="step-divider"></div>
            </div>

            <div class="step-item active">
              <div class="step-header">
                <span class="step-title">Step 2</span>
              </div>
              <div class="step-divider"></div>
            </div>

            <p>and also here.</p>
          </div>
        </template>
        <template #footer>
          <button class="action-button" @click="completeOverview">
            Complete Overview
          </button>
        </template>
      </PageSidebar>
    </template> -->
  </PageLayout>
</template>

<script>
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';
import PageHeader from '@/componentsv3/PageHeader.vue';
import DashboardService from '@/services/DashboardService-APP_TARGET';
import KpiService from '../services/KpiService';
import UiDataService from '@/services/UiDataService';
import { mapGetters, mapActions } from 'vuex';

import KpiBoard from '../componentsv3/KpiBoard/KpiBoard.vue';
import KpiSearchBar from '@/componentsv3/KpiSearchBar.vue';
import WaveBoard from '@/componentsv3/WaveBoard/WaveBoard.vue';
import { useBoardsHelpers } from '@/composables/boards-helpers';

import { Search } from 'lucide-vue-next';

export default {
  name: 'Overview',

  components: {
    PageLayout,
    PageSidebar,
    PageHeader,
    KpiBoard,
    KpiSearchBar,
    Search,
    WaveBoard
  },

  setup() {
    const BOARDS = useBoardsHelpers();
    return { BOARDS };
  },

  mounted() {
    this.tryLoadOverviewData();
  },

  watch: {
    isClientReady(newVal) {
      if (newVal && !this.boardSetup) {
        this.loadBoardSetup();
      }
      this.tryLoadOverviewData();
    },
    surveyIds() {
      this.tryLoadOverviewData();
    },
    filters() {
      this.tryLoadOverviewData();
    }
  },

  data() {
    return {
      boardData: {},
      boardSetup: undefined,
      focusKpis: [],
      overviewLoaded: false,
      structureItems: [],
      waves: [],
      waveData: {}
    }
  },

  computed: {
    ...mapGetters('auth', [ 'clientId', 'userDisplayName' ]),
    ...mapGetters('localization', [ 'currentLocalization', 'currentLocale' ]),
    ...mapGetters('clientData', [ 'brandIds', 'isClientReady', 'appLoading', 'structure', 'surveyIds', 'filters' ]),
    boards() {
      const list = this.boardSetup ? this.boardSetup?.Data?.overview?.active?.boards || [] : [];
      log.warn("BOARDS COMPUTED: ", list);
      return list;
    }
  },

  methods: {
    ...mapActions('app', [ 'toggleShowOffcanvas' ]),
    ...mapActions('clientData', [ 'setAppLoading' ]),

    async loadBoardSetup() {
      if (!this.clientId || !this.currentLocale) {
        log.warn("Cannot load board setup: clientId or locale missing");
        return;
      }
      this.setAppLoading(true);
      try {

        // DELAY 2000 ms for testing
        // await new Promise(resolve => setTimeout(resolve, 1000));

        this.boardSetup = await KpiService.getPageDetails(this.clientId, 'overview', this.currentLocale);
        log.warn("BOARD SETUP LOADED: ", this.boardSetup);
      } catch (error) {
        log.error("Error loading board setup:", error);
      } finally {
        this.setAppLoading(false);
      }
    },

    async tryLoadOverviewData() {
      if (this.overviewLoaded || !this.isClientReady || !this.filters) return;
      if (this.surveyIds.length > 0) {
        // Lade Board-Setup falls noch nicht vorhanden
        if (!this.boardSetup) {
          await this.loadBoardSetup();
        }
        this.overviewLoaded = true;
        await this.loadOverviewData();
      }
    },

    async loadOverviewData() {
      this.setAppLoading(true);

        // DELAY 2000 ms for testing
        // await new Promise(resolve => setTimeout(resolve, 1000));

      const filter = {
        api: APP_TARGET === 'bmw' ? 'bmw2021experimental' : undefined,
        brand: this.brandIds[0], // '1105^BMW', '1105^BMW|1105^MINI',
        clientId: this.clientId,
        waves: this.BOARDS.getWaves(this.filters.Waves, this.boards).join(','), // '1044,1174,1351,1352',
        regions: null, // '1106^C1',
        subregions: null,
        nscs: null,
        outlets: null,
        nscsub: null,
        areas: null,
        dealergroups: null,
        contactinitiation: null,
        surveys: this.BOARDS.getSurveys(this.filters.Waves, this.boards).join(','),
        // "-46,-53,-54,-41,-45,-47,-44,-42,-43", // surveys: [...this.surveyIds],
        page: 'overview',
       // relevantKpis: this.BOARDS.getRelevantKpis(this.boards).join(',')
      };

      await DashboardService.getDashboard(filter, null, this.currentLocale).
        then(response => {
          log.warn("DATA: " , response.data);
          this.boardData = response.data;
          this.waveData = this.getWaveData(response.data?.OverallByWave[0] || {});
        })
        .catch(error => {
          log.error('Error loading overview data:', error);
        })
        .finally(() => {
          this.setAppLoading(false);
        });
    },

    getWaveData(wrapper) {
      wrapper.SurveyWave = wrapper.SurveyWave || [];
      wrapper.SurveyWave.forEach(wave => {
        wave.country = wave.country || 'DE';
        wave.category = wave.category || 'Self Audit';
        wave.deadline = wave.deadline || new Date().toISOString();
        wave.status = wave.status || 'completed'; // active, completed, planned
        wave.total = wave.total || 12;
        wave.completed = wave.completed || 12;
        wave.processing = wave.processing || 0;
        wave.claimed = wave.claimed || 0;
      });

      if (wrapper.SurveyWave.length <= 1) {
        // Fallback: Beispiel-Daten
        wrapper.SurveyWave.push(
          {
            Id: 1,
            Name: 'Welle 02 - 2025/2026',
            country: 'DE',
            category: 'Customer Feedback',
            deadline: new Date(new Date().setDate(new Date().getDate() + 60)).toISOString(),
            status: 'planned',
            total: 100,
            completed: 0,
            processing: 0,
            claimed: 0
          }
        );
      }
      return wrapper;
    },

    fetchit(mode) {
      this.setAppLoading(true);
      KpiService.getSearchOptions(this.clientId, this.currentLocale, mode)
      .then(response => {
        log.warn("Search Options:", response.data);
      }).finally(() => {
        this.setAppLoading(false);
      });
      // Hier deine Fetch-Logik basierend auf dem Modus
    },

    handleRefresh() {
      log.log('Refreshing overview data...');
      // Hier deine Refresh-Logik
    },

    completeOverview() {
      log.log('Overview completed!');
      // Hier deine Completion-Logik
    },

    handleWaveDetailClick() {
      log.log('Navigate to wave details');
    },

    handleWaveClick(wave) {
      log.log('Wave clicked:', wave);
    }
  }
}
</script>

<style lang="scss">
.container-fluid {
  padding-left: unset !important;
  padding-right: unset !important;
}
</style>

<style lang="scss" scoped>
.overview-main-content {
  padding: 0 32px 32px;

  @media (max-width: 991px) {
    padding: 0 16px 16px;
  }

  h1 {
    font-size: 24px;
    font-weight: 600;
    color: var(--color-foreground);
    margin-bottom: 16px;
  }

  p {
    color: var(--color-muted-foreground);
    line-height: 1.6;
    margin-bottom: 12px;
  }
}

.kpi-autocomplete-section {
  margin: 24px 0;
  position: relative;
}

.autocomplete-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.autocomplete-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--color-accent);
  }

  strong {
    color: var(--color-foreground);
    font-weight: 600;
  }

  span {
    color: var(--color-muted-foreground);
    font-size: 14px;
  }
}

.custom-title {
  font-size: 28px;
  font-weight: 400;
  color: var(--color-foreground);
}

.overview-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-item {
  padding-bottom: 12px;
  cursor: pointer;

  &.active {
    .step-title {
      color: var(--color-foreground);
      font-weight: 600;
    }

    .step-divider {
      background-color: var(--color-border);
    }
  }
}

.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  transition: all 0.2s;

  &:hover {
    .step-title:not(.active) {
      color: var(--color-foreground);
    }
  }
}

.step-title {
  font-size: 16px;
  transition: all 0.2s;
  color: var(--color-muted-foreground);
  font-weight: normal;
}

.step-divider {
  height: 1px;
  width: 100%;
  background-color: var(--color-border);
  transition: background-color 0.2s;
}

.action-button {
  width: 100%;
  padding: 12px 24px;
  background-color: var(--target-primary);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
